const CSRF_STORAGE_KEY = '_csrf_token'

// In-memory fallback when localStorage is unavailable
let _csrfTokenFallback = ''

export const setCSRFToken = (token) => {
  _csrfTokenFallback = token
  try {
    localStorage.setItem(CSRF_STORAGE_KEY, token)
  } catch {
    // localStorage unavailable (e.g. private browsing quota exceeded);
    // in-memory fallback is already set above
  }
}

export const clearCSRFToken = () => {
  _csrfTokenFallback = ''
  try {
    localStorage.removeItem(CSRF_STORAGE_KEY)
  } catch {
    // Ignore errors
  }
}

export const getCSRFToken = () => {
  // Prefer the in-memory value when available — it's guaranteed to be the
  // most recent token set in this JS context.  localStorage is only used as
  // the primary source after a page refresh (when _csrfTokenFallback resets
  // to ''), which is the cross-tab sync benefit of persisting there.
  if (_csrfTokenFallback) {
    return _csrfTokenFallback
  }
  try {
    return localStorage.getItem(CSRF_STORAGE_KEY) || ''
  } catch {
    return ''
  }
}
